// extracted by mini-css-extract-plugin
export default {"card":"quizCard_card__DKHnW","point":"quizCard_point__SSUAX","isGreen":"quizCard_isGreen__Pwug5","rightArrow":"quizCard_rightArrow__LJAFd"};